module.exports = function() {
  return new Worker(__webpack_public_path__ + "a198c6f9ee6b54eee760.worker.js");
};